export default {
	'add-new-filter': '',
	filter: '',
	'the-filter': ''
}